<div class="sidecontent-option-container">
  <mat-toolbar class="sidemenu-toolbar">
    <i class="icon mdi mdi-cog"></i>
    <span class="title">Settings</span>
  </mat-toolbar>
  <div class="scroll-container" >
  <div class="app-name">
    <h3 class="title">{{applicationData.application_name}}</h3>
   
     
  </div>
  <div class="application-container" >
    
    <div class="mat-form-field-container" [formGroup]="applicationForm">
      <mat-form-field appearance="outline">
        <mat-label >Name</mat-label>
        <input matInput formControlName="applicationName" >
        <mat-error>This field cannot be empty.</mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label >Description</mat-label>
        <textarea matInput  formControlName="applicationDescription" maxlength="80" ></textarea>
      <mat-hint  class="hint">{{ applicationForm.get('applicationDescription')?.value?.length  }}/80 Characters
        Max</mat-hint>
      </mat-form-field>
    </div>
   

    <div class="app-icon-container">
      <div class="hint">App Icon</div>
      <mat-spinner *ngIf="loading" [id]="'applogo'" [diameter]="20" class="spinner"></mat-spinner>
      <div class="icon-img-container" matRipple (click)="openMediaPopUp($event)">
        <img [src]="blobUrl ?? imageSrc"  class="w-100" loading="lazy" (load)="loading = false" (error)="loading = false" #imageRef />
        <div class="edit-icon">
            <mat-icon>edit</mat-icon>
        </div>
      </div>
    </div>

      <div class="app-settings mt-2">
        <div class="toggle-container custom-toggle-container" style="background-color: #f5f5f5; padding: 15px; border-radius: 8px;">
          <mat-slide-toggle class="w-100" (change)="onToggleChange($event)" [checked]="offlineMode">
            <span matTooltip="Offline mode is used to run the application without internet connection.">Offline Mode</span>
          </mat-slide-toggle>
        </div>
        <div class="toggle-container custom-toggle-container" style="background-color: #f5f5f5; padding: 15px; border-radius: 8px;">
          <mat-slide-toggle class="w-100" (change)="onToggleChange($event,true)" [checked]="migrationEnabled">
            <span matTooltip="Offline mode is used to run the application without internet connection.">Public</span>
          </mat-slide-toggle>
        </div>
      </div>
      @if([appPermissions.editAppSettings,permissionsActions.edit] | builderPermissions){
          <div  class="actions">
            <button class="mt-3" mat-raised-button color="primary" [disabled]="applicationForm.invalid || showImageLengthError" (click)="onSaveClick()">Save Changes</button>
          </div>
        }
  </div>
  </div>
</div>